import { UserIcon } from "@heroicons/react/outline";
import {
  collection,
  addDoc,
  doc,
  deleteDoc,
  serverTimestamp,
} from "firebase/firestore";
import { useParams } from "react-router-dom";
import { database } from "../../database/firebase";

const RequestCard = ({
  memberName,
  memberImage,
  memberId,
  memberEmail,
  isAdmin,
  id,
}) => {
  const { roomId } = useParams();

  const acceptMember = async () => {
    try {
      await addDoc(collection(database, "userRooms", roomId, "members"), {
        memberName,
        memberImage,
        memberId,
        memberEmail,
        isAdmin,
        timestamp: serverTimestamp(),
      }).then(async () => {
        await deleteDoc(doc(database, "userRooms", roomId, "request", id));
      });
    } catch (error) {
      alert(error.message);
    }
  };
  const rejectMember = async () => {
    try {
      await deleteDoc(doc(database, "userRooms", roomId, "request", id));
    } catch (error) {
      alert(error.message);
    }
  };

  return (
    <div className="border flex flex-col space-y-5 border-gray-300 rounded-md shadow py-4">
      <div className="px-3">
        <h1 className=" font-semibold">
          {memberName} has requested to join the room ?
        </h1>
      </div>
      <div className="px-3">
        <div className="flex space-x-4 items-center border-b border-gray-300 pb-3">
          <div className="">
            {memberImage ? (
              <img
                src={memberImage}
                alt="user"
                className="h-10 rounded-full shadow"
              />
            ) : (
              <UserIcon className="h-10 px-2 py-2 rounded-full bg-gray-100 border border-gray-300 shadow" />
            )}
          </div>
          <div>
            <div className="flex flex-col space-y-2">
              <h1 className="font-semibold">{memberName}</h1>
              <p className="font-semibold text-gray-400">{memberEmail}</p>
            </div>
          </div>
        </div>
      </div>
      <div className="px-3 flex justify-between items-center py-2">
        <button
          onClick={rejectMember}
          className="px-4 py-2 border border-green-500 hover:bg-gray-100 text-green-500 text-sm rounded-md shadow"
        >
          Reject
        </button>
        <button
          onClick={acceptMember}
          className="px-4 py-2 border border-green-500 hover:bg-gray-100 text-green-500 text-sm rounded-md shadow"
        >
          Approve
        </button>
      </div>
    </div>
  );
};

export default RequestCard;
